// extracted by mini-css-extract-plugin
module.exports = {"balls":"Messaging_balls__2ddH0","wave":"Messaging_wave__3TOqz"};